import styled from 'styled-components';
import { Z_INDEX_500 } from '#/shared/constants';

export const NotificationBody = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.backgroundColor};
  user-select: none;
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  opacity: ${props => (props.visible ? 0.9 : 0)};
  transition: visibility 500ms ease-in-out, opacity 500ms ease-in-out;
  box-sizing: border-box;
  padding: 20px;
  z-index: ${Z_INDEX_500};
`;

export const NotificationContent = styled.div`
  flex: 1;
  text-align: center;
  font-size: 1.2em;
  color: ${props => props.theme.primaryFontColor};
`;
